// extracted by mini-css-extract-plugin
module.exports = {"s_container":"EmployerLayout_s_container__MYv96","main":"EmployerLayout_main__25rtl","content":"EmployerLayout_content__3wHKX","page":"EmployerLayout_page__3fs6D"};